import { ApplicationConfig, ErrorHandler, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  MsalTokenInterceptor,
  apiRoutingInterceptor,
  resolveSignalRBase,
  SHARED_ENVIRONMENT,
  SignalRService,
  CFIErrorHandlerService,
  InactivityMonitorService
} from '@k12/app-services';
import { environment } from '../environments/environment';
import { provideEnvironmentNgxMask } from 'ngx-mask';

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptorsFromDi(), withInterceptors([
      (req, next) => apiRoutingInterceptor(req, next),
      (req, next) => MsalTokenInterceptor(req, next)
    ])),
    provideAnimationsAsync(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
    provideEnvironmentNgxMask(),
    { provide: ErrorHandler, useClass: CFIErrorHandlerService },
    InactivityMonitorService,
    { provide: SHARED_ENVIRONMENT, useValue: environment },
    provideAppInitializer( async () => {
      const signalRService = inject(SignalRService);
      await signalRService.startConnection(resolveSignalRBase(environment), ['SchoolEvents', 'TaskEvents']);
      // SignalR event relay (internal Subject); cannot error by construction, so no error handler is needed.
      signalRService.getEventObservable<never>('TaskStatusUpdate').subscribe((taskStatus) => {
        console.log('Task Status Update:', taskStatus);
        // Handle task status update here
      });
    })
  ]
};
